import React, { useEffect, useState } from "react";
import _OrderRow from "./_OrderRow";
import { FaSearch } from "react-icons/fa";
import { useAppContext } from "../../../../../../Components/AppProvider";
import Modal from "../../../../../../PageCostumerProfile/PCPContents/Contents/Order History/Modal/Modal";
import CancelForm from "../Modal/CancelForm/CancelForm";

function _Unpaid() {
  const [expandedId, setExpandedId] = useState(null);
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [unpaidOrder, setUnpaidOrder] = useState([]);
  const [updateUnpaidOrder, setUpdateUnpaidOrder] = useState(false);

  const { setCountListUpdate } = useAppContext();
  // ✅ search state
  const [searchTerm, setSearchTerm] = useState("");

  // ✅ keep track of selected orders
  const [selectedOrders, setSelectedOrders] = useState([]);

  const [singleOrderToCancel, setSingleOrderToCancel] = useState(null);
  const [singleOrderToPay, setSingleOrderToPay] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const handelCancelModal = () => {
    setModalOpen(true); // open modal
  };

  useEffect(() => {
    let intervalId;

    async function fetchOrderContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-unpaid-order`,
          { credentials: "include" }
        );

        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }

        const data = await res.json();
        if (Array.isArray(data.unpaidOrder)) {
          setUnpaidOrder(data.unpaidOrder);
          //console.log("data.unpaidOrder :", data.unpaidOrder);
        } else {
          console.error("Invalid response:", data);
          setUnpaidOrder([]);
        }
      } catch (err) {
        console.error("Failed to fetch pending orders", err);
        setUnpaidOrder([]);
      }
    }

    fetchOrderContent(); // run once immediately

    // auto-refresh every 10 seconds
    intervalId = setInterval(fetchOrderContent, 10000);

    // cleanup on unmount or dependency change
    return () => clearInterval(intervalId);
  }, [updateUnpaidOrder]);

  // 🔹 Approve a single order
  // 🔹 Approve one order

  // ✅ filter orders based on search term
  const filteredOrders = unpaidOrder.filter((order) => {
    const keyword = searchTerm.toLowerCase();

    const displayStatus =
      order.COI_Status === "PayFull" ? "DP PAID" : order.COI_Status || "";

    return (
      order.PD_Name?.toLowerCase().includes(keyword) ||
      order.PO_Number?.toLowerCase().includes(keyword) ||
      `${order.CP_Firstname} ${order.CP_Lastname}`
        .toLowerCase()
        .includes(keyword) ||
      displayStatus.toLowerCase().includes(keyword)
    );
  });

  // ✅ handle toggle of one row
  const handleRowSelect = (id) => {
    setSelectedOrders((prev) =>
      prev.includes(id) ? prev.filter((oid) => oid !== id) : [...prev, id]
    );
  };

  // ✅ handle toggle all
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedOrders(filteredOrders.map((o) => o.COI_ID));
    } else {
      setSelectedOrders([]);
    }
  };

  // ✅ check if all are selected
  const allSelected =
    filteredOrders.length > 0 &&
    filteredOrders.every((o) => selectedOrders.includes(o.COI_ID));

  const handleCancelOrder = async (reason) => {
    let ordersToCancel = [];

    if (singleOrderToCancel) {
      // ✅ FIXED: use the right state
      ordersToCancel = [singleOrderToCancel];
    } else {
      ordersToCancel = filteredOrders.filter((order) =>
        selectedOrders.includes(order.COI_ID)
      );
    }

    if (ordersToCancel.length === 0) return;

    const confirmCancel = window.confirm(
      `Are you sure you want to cancel ${ordersToCancel.length} order(s)?`
    );
    if (!confirmCancel) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/orders/admin-cancel`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ orders: ordersToCancel, reason }),
        }
      );

      if (!res.ok) throw new Error("Failed to cancel order(s)");

      alert("Order(s) cancelled successfully!");

      // 🔹 Reset selection and refresh list
      setSelectedOrders([]);
      setSingleOrderToCancel(null); // ✅ clear it
      setUpdateUnpaidOrder((p) => !p);
      setCountListUpdate((prev) => !prev);
    } catch (err) {
      console.error(err);
      alert("Failed to cancel order(s). Please try again.");
    }
  };

  return (
    <>
      <main className="ad-order-panel-container">
        <div className="order-panel-header">
          <div className="order-panel-title-wrapper">
            <span>UNPAID ORDERS</span>
          </div>
          <div className="order-panel-actions-wrapper">
            {/* ✅ Only show button when there are selected orders */}
            {selectedOrders.length > 0 && (
              <>
                <button
                  onClick={() => {
                    setSingleOrderToPay(null);
                    handelCancelModal();
                  }}
                >
                  CANCEL ORDER ({selectedOrders.length})
                </button>
              </>
            )}

            <div className="order-search-bar">
              <input
                type="text"
                placeholder="Keyword..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span>
                <FaSearch />
              </span>
            </div>
          </div>
        </div>

        <div className="order-panel-table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={allSelected}
                    onChange={handleSelectAll}
                  />
                </th>
                <th></th>
                <th>PRODUCT NAME</th>
                <th>CUSTOMER NAME</th>
                <th>ORDER TYPE</th>
                <th>DATE ORDERED</th>
                <th>UNIT PRICE</th>
                <th>QTY</th>
                <th>TOTAL DP</th>
                <th>TOTAL AMOUNT</th>
                <th>STATUS</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.length > 0 ? (
                filteredOrders.map((order) => (
                  <_OrderRow
                    key={order.COI_ID}
                    order={order}
                    menuOpenId={menuOpenId}
                    setMenuOpenId={setMenuOpenId}
                    isSelected={selectedOrders.includes(order.COI_ID)}
                    onSelect={() => handleRowSelect(order.COI_ID)}
                    setExpandedId={setExpandedId}
                    expandedId={expandedId}
                    handelCancelModal={handelCancelModal}
                    setSingleOrderToCancel={setSingleOrderToCancel}
                  />
                ))
              ) : (
                <tr>
                  <td
                    colSpan="12"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </main>
      <Modal
        isModalOpen={isModalOpen}
        onClose={() => {
          setModalOpen(null);
          setSingleOrderToCancel(null); // ✅ reset when closing modal
        }}
      >
        <CancelForm
          onClose={() => setModalOpen(null)}
          selectedOrders={
            singleOrderToCancel
              ? [singleOrderToCancel] // ✅ single order mode
              : filteredOrders.filter((order) =>
                  selectedOrders.includes(order.COI_ID)
                ) // ✅ bulk mode
          }
          handleCancelOrder={handleCancelOrder}
        />
      </Modal>
    </>
  );
}

export default _Unpaid;
